export const DefaultOptions = {
  tabWidth: 2,
  useTabs: false
}

export default async function formatHTML(input, options = {}) {
  const {tabWidth, useTabs} = {...DefaultOptions, ...options}

  const prettier = (await import('prettier/standalone')).default
  const parserHtml = (await import('prettier/parser-html')).default

  return prettier.format(input, {
    parser: 'html',
    plugins: [parserHtml],
    tabWidth,
    useTabs,
  })
}
